import DashboardOIGSAMAdminTable from "./DashboardOIGSAMAdminTable";
export default DashboardOIGSAMAdminTable;